import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";
import { ArticleDetails } from "@/components/article/article-details";
import { FullPageLoading } from "@/components/full-page-loading";
import { ArticleEditorProvider } from "@/context/article-editor-context";
import {
  CollaborationProviderProvider,
  useCollaborationProviderSafe,
} from "@/context/collaboration-provider-context";
import { MediaPickerProvider } from "@/context/media-library-context";

export const Route = createFileRoute("/_auth-init-space/_authorized/stories/$articleId")({
  component: StoryDetailRoute,
  validateSearch: zodValidator(
    z.object({
      tab: z.enum(["content", "metadata"]).catch("content").default("content"),
      template: z.enum(["blank", "puzzle", "takeover"]).optional(),
      puzzleVariant: z.string().optional(),
      puzzleNumber: z.string().optional(),
      embedUrl: z.string().optional(),
      folderName: z.string().optional(),
    }),
  ),
});

function StoryDetailRoute() {
  const { articleId } = Route.useParams();

  return (
    <CollaborationProviderProvider articleId={articleId} key={articleId}>
      <LoadingGuard>
        <ArticleEditorProvider articleId={articleId}>
          <MediaPickerProvider>
            <ArticleDetails />
          </MediaPickerProvider>
        </ArticleEditorProvider>
      </LoadingGuard>
    </CollaborationProviderProvider>
  );
}

function LoadingGuard({ children }: { children: React.ReactNode }) {
  const { isReady, provider } = useCollaborationProviderSafe();

  if (!isReady || !provider) {
    return <FullPageLoading text="Loading story data..." />;
  }

  return children;
}
